export const searchPolicySelector = (state: any) =>
  state.getIn(['policies', 'policy']);
